export const SHOW_ELEV8_PRICES = "show_elev8_prices";
export const ENABLE_PRICE_UNIFICATION = "enable_price_unification";
